const KEY = 'indilabs_applications';

export function generateAppId() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let s = '';
  for (let i = 0; i < 6; i++) s += chars[Math.floor(Math.random() * chars.length)];
  return `INDI-${s}`;
}

export function saveApplication(answers, existingId = null) {
  if (existingId) {
    return updateApplication(existingId, answers);
  }
  const record = {
    id: generateAppId(),
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    answers,
  };
  try {
    const list = getApplications();
    list.unshift(record);
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) {
    // storage may be unavailable; still return the record
    console.warn('Gagal menyimpan ke localStorage', e);
  }
  return record;
}

export function updateApplication(id, answers) {
  try {
    const list = getApplications();
    const idx = list.findIndex((r) => r.id === id);
    if (idx >= 0) {
      list[idx] = { ...list[idx], answers, updatedAt: new Date().toISOString() };
      localStorage.setItem(KEY, JSON.stringify(list));
      return list[idx];
    }
  } catch (e) {
    console.warn('Gagal memperbarui localStorage', e);
  }
  // fallback: create fresh
  return saveApplication(answers);
}

export function getApplications() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
}

export function formatIDR(n) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(n || 0);
}
